/**
 * AttachmentsViewElement — kreator formatek: klocek palety reprezentujący
 * tabelkę załączników rekordu (`attachments_view`, patrz
 * `RecursiveFormRenderer` PLACEHOLDER_TYPES).
 *
 * Mirror `DocumentItemsViewElement` (patrz nagłówek tamtego pliku) — na
 * REALNEJ stronie rekordu ten typ jest dispatchowany WYŁĄCZNIE przez
 * `contextRenderers['attachments_view']` (widget `AttachmentsSection` —
 * powstaje osobno, poza zakresem tego rejestru). Ten plik obsługuje TYLKO
 * podgląd w canvasie buildera (mode='builder'), gdzie nie ma prawdziwego
 * rekordu do wyświetlenia.
 *
 * `allowedModules` scopinguje ten klocek do hostów tej iteracji — lista wydzielona
 * do `./attachment-host-modules.ts` (dzielona z `DocumentPreviewViewElement`, który ma
 * IDENTYCZNY zakres hostów — patrz nagłówek tamtego pliku).
 *
 * `render` jest wołany jak ZWYKŁA FUNKCJA (nie komponent) — patrz
 * `LayoutElementRegistry.render` — więc żaden hook nie może być wywołany
 * BEZPOŚREDNIO w jej ciele (ten sam powód co w `DocumentItemsViewElement`):
 * `i18n.t` standalone zamiast `useTranslation`.
 */

import { Paperclip } from 'lucide-react';

import type { LayoutElementDefinition } from '@/components/fields/LayoutElementRegistry';
import i18n from '@/i18n';

import { ATTACHMENT_HOST_ALLOWED_MODULES } from './attachment-host-modules';

export const AttachmentsViewElement: LayoutElementDefinition = {
  type: 'attachments_view',
  category: 'tresc',
  isContainer: false,
  label: 'Załączniki',
  icon: 'Paperclip',
  allowedModules: ATTACHMENT_HOST_ALLOWED_MODULES,
  defaultSettings: () => ({}),
  render: ({ element }) => (
    <div
      className="rounded-lg border border-dashed border-border-secondary bg-bg-secondary p-4 text-center"
      data-testid={`attachments-view-element-${element.id}`}
      data-element-type="attachments_view"
    >
      <Paperclip className="mx-auto h-5 w-5 text-text-muted" aria-hidden="true" />
      <p className="mt-1 text-xs font-medium text-text-secondary">
        {i18n.t('attachments.paletteLabel', { defaultValue: 'Załączniki' })}
      </p>
    </div>
  ),
};
